export const rank = state => state.rank;
export const search = state => state.search;
export const book = state => state.book;
